import React, { useState, useRef, useEffect } from "react";
import "./Universites.scss";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import { Dropdown } from "primereact/dropdown";
import Universite from "Components/Universite/Universite";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  shuffleArray,
  findManagementContentByLabel,
  sanitizeHtml,
} from "../../Services/functions";
import parse from "html-react-parser";
import { HTMLParseOptions } from "Services/htmlParseOptions";
/**
 * Permet d'affiche les informations concernant les universités avant connexion
 */
const Universites = (props) => {
  const [univFiltered, setUnivFiltered] = useState("Toutes");
  const universiteContainerRef = useRef(null);

  useEffect(() => {
    if (universiteContainerRef.current !== null) {
      window.scroll({
        top: universiteContainerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, []);

  const handleFilteredUniv = () => {
    return [
      props.universities.universitiesData.find(
        (univ) => univ.label === univFiltered
      ),
      ...shuffleArray([
        ...props.universities.universitiesData.filter(
          (univ) => univ.label !== univFiltered
        ),
      ]),
    ];
  };
  return (
    <div className="universites">
      <Header />
      {!props.auth.isConnected && (
        <div className="universites__container" ref={universiteContainerRef}>
          <div className="universites__container__top">
            <div className="universites__container__top__title">
              <h1 className="h1_trait_dessus">
                Comment faire partie de Réseau Pro ?
              </h1>
            </div>
            <div>
              {parse(
                sanitizeHtml(
                  findManagementContentByLabel(
                    "partieRP",
                    props.admin.editManagement,
                    props.admin.editManagementNexus
                  ).content || "partiRPDefault"
                ),
                HTMLParseOptions
              )}
            </div>
          </div>
          <div className="universites__container__bottom">
            <div className="universites__container__bottom__title">
              <h1 className="h1_trait_dessus">
                Présentation de nos universités
              </h1>
              <Dropdown
                placeholder="Sélectionnez une université"
                value={univFiltered}
                options={[
                  { label: "Toutes" },
                  ...props.universities.universitiesData,
                ]}
                optionLabel="label"
                onChange={(e) => setUnivFiltered(e.value.label)}
              />
            </div>
            <div key={univFiltered}>
              {univFiltered === "Toutes"
                ? shuffleArray(props.universities.universitiesData).map(
                    (univ, index) => <Universite key={index} univ={univ} />
                  )
                : handleFilteredUniv().map((univ) => (
                    <Universite key={univ.id} univ={univ} />
                  ))}
            </div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

Universites.propTypes = {
  auth: PropTypes.object,
  admin: PropTypes.object,
  universities: PropTypes.object,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
  universities: state.universities,
});

export default connect(mapStateToProps)(Universites);
